import { render, staticRenderFns } from "./response.vue?vue&type=template&id=4ef9fa16"
import script from "./response.vue?vue&type=script&lang=js"
export * from "./response.vue?vue&type=script&lang=js"
import style0 from "./response.vue?vue&type=style&index=0&id=4ef9fa16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports